import { mapMutations } from 'vuex'
import maInputText from '@/components/input/modules/text'
import maOtpInput from '@/components/input/modules/otp'
import maConfrimBtn from '@/components/button-blue'
import maModal from '@/components/modal'
import vOtpInput from '@bachdgvn/vue-otp-input'
import userLoginMixin from '@/modules/User/mixins/userLoginMixin'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

import {
  apiPostValidateOtp,
  apiGetSendOtp
} from '@/modules/User/services/authentication'
import { apiGetDamage } from '@/modules/Damage/services/damages'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_SINISTER_SUMMARY
} from '@/store/types'

import * as Sentry from '@sentry/vue'

/**
 * @module
 * @name Otp
 */
export default {
  name: 'otp',
  mixins: [userLoginMixin, flowMixin],
  data: function () {
    return {
      loading: false,
      otpValCode: '',
      inputsNumber: 6,
      clipboardData: null,
      keyBoadKey: null,
      navbar: document.querySelector('.nav-bar')
    }
  },
  computed: {
    getPhone() {
      if (sessionStorage.getItem('telephone')) {
        const phoneNumber = sessionStorage.getItem('telephone')
        return `xx xx xx${phoneNumber.substring(0, 2)}${phoneNumber.substring(
          2,
          4
        )} `
      } else {
        return ``
      }
    },
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtnWhite'
    },

    getSinisterId() {
      return this.stateWarrantySinisterId || sessionStorage.getItem('sinId')
    },

    async initI18n() {
      return this.initI18n('lang')
    },

    isDisabledButton() {
      return this.otpValCode.length < this.inputsNumber
    }
  },
  components: {
    maInputText,
    maConfrimBtn,
    maModal,
    vOtpInput,
    maOtpInput
  },
  created() {
    // window.addEventListener('resize', this.checkWindowResize)
  },
  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateSinisterSummary: WARRANTY_UPDATE_SINISTER_SUMMARY
    }),
    async handleValidateOtp() {
      // Validate OTP agains API and set token in local storage if its valid
      this.loading = true
      try {
        const token = await apiPostValidateOtp(
          sessionStorage.getItem('sinId'),
          this.otpValCode
        )
        if (token) {
          sessionStorage.setItem('mavAuth', `Token ${token.token}`)
          await this.getUserData()
          await this.trackFlowStart()
          await apiGetDamage(this.$route.query.sinisterId).then((damages) => {
            this.mutWarrantyUpdateSinisterSummary(damages)
          })
          sessionStorage.setItem('user', 'scuser')
          const name = 'claim-home'
          this.$router
            .push({
              name: 'claim-home',
              params: { name },
              query: { ...this.$route.query }
            })
            .catch((e) => {})
          this.loading = true
          this.navbar.classList.remove('hidden')
        } else {
          // Send sentry custom event
          const scope = new Sentry.Scope()
          scope.setTag('section', 'otp')
          Sentry.captureException(
            new Error(`Error valid ${token}`),
            () => scope
          )

          const messageNotification = this.$t('otpView.text.errorNotification')
          this.throwNotification(messageNotification, messageNotification, 'KO')
          this.loading = false
          return false
        }
      } catch (e) {
        // Send sentry custom event
        const scope = new Sentry.Scope()
        scope.setTag('section', 'otp')
        Sentry.captureException(
          new Error(`Error ${e}. Error await apiPostValidateOtp`),
          () => scope
        )
        const messageNotification = this.$t('otpView.text.errorNotification')
        this.throwNotification(messageNotification, messageNotification, 'KO')
        this.loading = false
        return false
      }
    },

    async handleResendSMS() {
      this.loading = true
      const encSinisterId = this.$route.query.sinisterId
      try {
        const data = await apiGetSendOtp(encSinisterId)
        sessionStorage.setItem('sinId', data.sinisterId)
        sessionStorage.setItem('formId', data.formId)
        sessionStorage.setItem('telephone', data.telephone)
        this.loading = false
      } catch (e) {
        this.$router
          .push({ name: 'timedout', query: { ...this.$route.query } })
          .catch((e) => {})
        this.loading = false
      }
    },

    handleOnChange(value) {
      this.otpValCode = value
    },
    checkWindowResize(e) {
      window.scrollTo(0, 0)
    },
    openInfoModal() {
      this.$refs.modalInfoOtp.showModal = true

      if (this.$refs.modalInfoOtp.showModal) {
        // Send sentry custom event
        const scope = new Sentry.Scope()
        scope.setTag('section', 'otp')
        Sentry.captureException(new Error(`User open otp modal`), () => scope)
      }
    },
    trackFlowStartSendOtp() {
      const startTrackMessage = `Selfcare - Send Otp`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    },
    trackFlowStart() {
      const startTrackMessage = `Selfcare - Try login`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    },
    handleInputPaste() {
      const otpContent = this.$refs.otpCode.$el
      const otpContainer = this.$refs.otpCode

      //Need the key to difference if user write the code o paste.
      otpContent.addEventListener('keydown', (event) => {
        this.keyBoadKey = event.keyCode
      })

      const otpLength = 1
      const key = 229

      const firstNumberCode = otpContainer.otp[0]
      //when copying from the keyboard only pastes one value, so first check if the value of otp is only one and pass the information to the handleOnPaste event of the library. SOMETHING WE HAVE TO TEST
      if (otpContainer.otp.length === otpLength && this.keyBoadKey === key) {
        navigator.clipboard
          .readText()
          .then((code) => {
            const regex = /^[0-9]*$/
            const number = regex.test(code)
            const firstChaptCode = code.charAt(0)
            if (
              code.length === this.inputsNumber &&
              firstNumberCode == firstChaptCode &&
              number
            ) {
              this.clipboardData = code.substring(1)
            }

            otpContainer.handleOnPaste({
              clipboardData: { getData: () => this.clipboardData },
              preventDefault: () => {}
            })

            this.clipboardData = null
          })
          .catch((err) => {
            console.error('Failed to read clipboard contents: ', err)
          })
      }
    },
    hiddenNavbar() {
      if (this.$route.name === 'otp') {
        this.navbar.classList.add('hidden')
      }
    }
  },
  mounted() {
    this.hiddenNavbar()
  }
}
